// extracted by mini-css-extract-plugin
var _1 = "ViewingApplicantPreviewSection-moduleViewingApplicantPreviewSection__tRzcl";
var _2 = "ViewingApplicantPreviewSection-modulerowLabel__i5FNL";
var _3 = "ViewingApplicantPreviewSection-modulerowStatus__Sqa2S";
var _4 = "ViewingApplicantPreviewSection-modulerowValue__rmHea";
var _5 = "ViewingApplicantPreviewSection-modulerows__np1Dk";
var _6 = "ViewingApplicantPreviewSection-moduletitle__V0jda";
export { _1 as "ViewingApplicantPreviewSection", _2 as "rowLabel", _3 as "rowStatus", _4 as "rowValue", _5 as "rows", _6 as "title" }
